import { LessonHomeworkId, SubmittedField } from '../../commonv3/types/lesson_homeworks';
import { MainV3ApiBase } from './base';

export const LessonHomeworkApis = {
    show(id: LessonHomeworkId) {
        return MainV3ApiBase.appendPath('lesson_homeworks')
            .withId(id)
            .get();
    },
    submit(id: LessonHomeworkId, submittedFields: SubmittedField[]) {
        return MainV3ApiBase.appendPath('lesson_homeworks')
            .withId(id)
            .appendPath('submissions')
            .post({
                submitted_fields: submittedFields,
            });
    },
};
